import update from 'immutability-helper';

import {findIndex} from 'utils';

import {WisbitState, WisbitActionTypes} from '../types';

import {
  SAVE_WISBIT_FAILURE,
  SAVE_WISBIT_SUCCESS,
  LOAD_TAGS_FAILURE,
  LOAD_TAGS_SUCCESS,
  LOAD_WISBIT_SUCCESS,
  LOAD_WISBIT_FAILURE,
  LOAD_TAGS_REQUEST,
  CHANGE_TITLE,
  CHANGE_DESCRIPTION,
  CHANGE_DATE,
  CHANGE_TAGS,
  CHANGE_THUMBNAIL,
  CREATE_BIT,
  DELETE_BIT,
  MOVE_BIT,
  UPDATE_BIT_TITLE,
  UPDATE_BIT_COMPONENT,
  CREATE_BIT_COMPONENT,
  DELETE_BIT_COMPONENT,
  INITIATE_WISBIT,
  UPDATE_BIT_DURATION,
  SAVE_WISBIT_REQUEST,
  LOAD_WISBIT_REQUEST,
  DELETE_WISBIT_FAILURE,
  PUBLISH_WISBIT_FAILURE,
  CLEAR_LOADING,
  PUBLISH_WISBIT_SUCCESS,
  DELETE_WISBIT_SUCCESS,
  UPDATE_TAGS,
} from './actions';

const initialState: WisbitState = {};

export default function wisbitReducer(
  state = initialState,
  action: WisbitActionTypes
): WisbitState {
  const {type, payload} = action;

  switch (type) {
    case SAVE_WISBIT_REQUEST:
      return update(state, {
        saving: {$set: true},
        showSavedMessage: {$set: false},
      });
    case SAVE_WISBIT_SUCCESS:
      return update(state, {
        $merge: {
          ...payload,
          tags: payload.tags || [],
        },
        saving: {$set: false},
        showSavedMessage: {$set: true},
      });
    case LOAD_TAGS_REQUEST:
      return update(state, {
        $merge: {
          allTags: undefined,
          error: undefined,
        },
      });
    case LOAD_TAGS_SUCCESS:
      return update(state, {
        allTags: {$set: payload.allTags},
      });
    case LOAD_WISBIT_REQUEST:
      return update(state, {
        id: {$set: payload.id},
        showSavedMessage: {$set: false},
        loading: {$set: true},
        error: {$set: undefined},
      });
    case LOAD_WISBIT_SUCCESS:
      return update(state, {
        $merge: {...payload},
        loading: {$set: false},
      });
    case INITIATE_WISBIT: {
      return update(initialState, {
        loading: {$set: payload.loading},
        bits: {$set: payload.bits},
        template: {$set: payload.template},
      });
    }
    case CHANGE_TITLE:
      return update(state, {
        title: {$set: payload.title},
      });
    case CHANGE_DESCRIPTION:
      return update(state, {
        description: {$set: payload.description},
      });
    case CHANGE_DATE:
      return update(state, {
        date: {$set: payload.date},
      });
    case CHANGE_TAGS:
      return update(state, {
        tags: {$set: payload.tags},
      });
    case CHANGE_THUMBNAIL:
      return update(state, {
        $merge: {
          thumbnailId: payload.thumbnailId,
        },
      });
    case CREATE_BIT: {
      const newBit = payload.selectedBit ? [{...payload.selectedBit}] : [];

      return update(state, {
        bits: state.bits ? {$push: newBit} : {$set: newBit},
      });
    }
    case DELETE_BIT: {
      const index = findIndex(state.bits, payload.selectedBit);

      return update(state, {
        bits: {$splice: [[index, 1]]},
      });
    }
    case UPDATE_BIT_TITLE: {
      const index = findIndex(state.bits, payload.selectedBit);

      return update(state, {
        bits: {[index]: {title: {$set: payload.selectedBit?.title}}},
      });
    }
    case UPDATE_BIT_DURATION: {
      const index = findIndex(state.bits, payload.selectedBit);

      return update(state, {
        bits: {
          [index]: {duration: {$set: payload.selectedBit?.duration}},
        },
      });
    }
    case CREATE_BIT_COMPONENT: {
      if (!state.bits) {
        return state;
      }

      const index = findIndex(state.bits, payload.selectedBit);

      const newComponentArray = payload.selectedBit?.selectedComponent
        ? [payload.selectedBit?.selectedComponent]
        : [];

      return update(state, {
        bits: {
          [index]: {
            components: state.bits[index].components
              ? {$push: newComponentArray}
              : {$set: newComponentArray},
          },
        },
      });
    }
    case DELETE_BIT_COMPONENT: {
      if (!state.bits) {
        return state;
      }

      const bitIndex = findIndex(state.bits, payload.selectedBit);

      if (bitIndex < -1) {
        return state;
      }

      const componentIndex = findIndex(
        state.bits[bitIndex].components,
        payload.selectedBit?.selectedComponent
      );

      return update(state, {
        bits: {
          [bitIndex]: {
            components: {$splice: [[componentIndex, 1]]},
          },
        },
      });
    }
    case UPDATE_BIT_COMPONENT: {
      if (!state.bits || !payload.selectedBit?.selectedComponent) {
        return state;
      }

      const bitIndex = findIndex(state.bits, payload.selectedBit);

      if (bitIndex < -1) {
        return state;
      }

      const componentIndex = findIndex(
        state.bits[bitIndex].components,
        payload.selectedBit?.selectedComponent
      );

      return update(state, {
        bits: {
          [bitIndex]: {
            components: {
              [componentIndex]: {$set: payload.selectedBit.selectedComponent},
            },
          },
        },
      });
    }
    case MOVE_BIT:
      return update(state, {
        bits: {$set: payload.bits},
      });
    case PUBLISH_WISBIT_SUCCESS:
      return update(state, {
        published: {$set: true},
      });
    case DELETE_WISBIT_SUCCESS: {
      return update(state, {
        deleted: {$set: true},
      });
    }
    case LOAD_WISBIT_FAILURE:
    case SAVE_WISBIT_FAILURE:
    case LOAD_TAGS_FAILURE:
    case DELETE_WISBIT_FAILURE:
    case PUBLISH_WISBIT_FAILURE:
      return update(state, {
        error: {
          $set: payload.error,
        },
        loading: {$set: false},
        saving: {$set: false},
      });
    case CLEAR_LOADING:
      return update(state, {
        loading: {$set: false},
      });
    case UPDATE_TAGS:
      return update(state, {
        tags: {$set: action.payload.tags},
      });
    default:
      return state;
  }
}
